import { PrimaryButton, Space, TertiaryButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { CreateBeneficiaryFormSkeleton } from './components/CreateBeneficiaryFormSkeleton'
import messages from './messages'
import { CreateBeneficiaryFormEmbeddedFormStyled } from './styles/CreateBeneficiaryFormEmbeddedFormStyled'
import { CreateBeneficiaryFormFooterStyled } from './styles/CreateBeneficiaryFormFooterStyled'
import { CreateBeneficiaryFormStyled } from './styles/CreateBeneficiaryFormStyled'

export const MOUNT_ELEMENT_ID = 'beneficiary-component-mount'

export interface ICreateBeneficiaryFormProps {
  onSubmit: () => void
  onBack: () => void
  isDisabled: boolean
  isLoading: boolean
  isSubmitting: boolean
}

export const CreateBeneficiaryForm = ({
  onSubmit,
  onBack,
  isDisabled,
  isLoading,
  isSubmitting,
}: ICreateBeneficiaryFormProps) => {
  const intl = useProcurifyIntl()

  return (
    <CreateBeneficiaryFormStyled>
      <CreateBeneficiaryFormEmbeddedFormStyled
        mountElementId={MOUNT_ELEMENT_ID}
      >
        {isLoading && <CreateBeneficiaryFormSkeleton />}
        <div id={MOUNT_ELEMENT_ID} />
      </CreateBeneficiaryFormEmbeddedFormStyled>
      <CreateBeneficiaryFormFooterStyled>
        <Space direction='vertical' justify='center' align='stretch'>
          <PrimaryButton
            type='button'
            disabled={isDisabled || isLoading || isSubmitting}
            isLoading={isLoading}
            onClick={onSubmit}
            aria-label={intl.formatMessage(
              messages.addPaymentMethodButtonLabel
            )}
            fullWidth
          >
            {intl.formatMessage(messages.addPaymentMethodButtonLabel)}
          </PrimaryButton>
          <TertiaryButton
            type='button'
            disabled={isDisabled}
            onClick={onBack}
            aria-label={intl.formatMessage(messages.backButtonLabel)}
            fullWidth
          >
            {intl.formatMessage(messages.backButtonLabel)}
          </TertiaryButton>
        </Space>
      </CreateBeneficiaryFormFooterStyled>
    </CreateBeneficiaryFormStyled>
  )
}
